<template>
  <FrontHubView />
</template>